<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Imagen</h1>
    <div class="information" v-if="image">
      <img :src="cover" :alt="image.name" class="information__image information__image--wide">
      <p class="information__text"><strong class="information__text--strong">Nombre: </strong>{{image.name}}</p>
      <p v-if="image.title" class="information__text"><strong class="information__text--strong">Título: </strong>{{image.title}}</p>
      <p v-if="image.description" class="information__text"><strong class="information__text--strong">Descripción: </strong><br><span v-html="description"></span></p>
      <p v-if="image.gallery_name" class="information__text"><strong class="information__text--strong">Galería: </strong>{{image.gallery_name}}</p>
      <p v-if="image.group_name" class="information__text"><strong class="information__text--strong">Grupo: </strong>{{image.group_name}}</p>
      <p v-if="image.url" class="information__text"><strong class="information__text--strong">Enlace: </strong><a :href="image.url" target="_blank" class="information__text--link" v-text="image.url"></a></p>
      <p v-if="image.url_type" class="information__text"><strong class="information__text--strong">Tipo de Enlace: </strong>{{image.url_type_name}}</p>
      <p v-if="image.sort" class="information__text"><strong class="information__text--strong">Posición: </strong>{{image.sort}}</p>
      <p v-if="status" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{status}}</p>
    </div>
  </div>
</template>

<script>
import {images_status} from './mocks'
import {nl2br} from '@/core/libs/functions'
import {config} from '@/core/config/base'
export default {
  props: {
    image: {
      type: Object
    }
  },
  computed: {
    status: function () {
      let status = images_status.filter(element => element.id === this.image.status_id)
      return status[0].name
    },
    description: function () {
      return nl2br(this.image.description)
    },
    cover: function () {
      let img = ''
      if (this.image.image) {
        img = config.statics.url + JSON.parse(this.image.image).sizes.small
      }
      return img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery_images/view.vue